import * as Label from "@radix-ui/react-label";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import s from "./Checkbox.module.css";
import { FC } from "react";
import { Icon } from "../Icon";

export type ColorCheckboxProps = {
  identifier: string;
  label: string;
  properties?: any;
  onCheckedChange?: (value: boolean) => void;
  checked?: boolean;
  value?: string | number;
  color: string;
  className?: string;
  disabled?: boolean;
};
export const ColorCheckbox: FC<ColorCheckboxProps> = ({
  identifier,
  label,
  properties = {},
  onCheckedChange = () => {},
  checked = false,
  disabled = true,
  className = "",
  color,
}) => {
  const { gridColumnClassAutoConfiguration = {}, elementClassAttribute = "" } =
    properties;
  const { viewPorts = {} } = gridColumnClassAutoConfiguration;

  return (
    <div
      className={` flex-col justify-center items-center ${
        disabled ? "!hidden" : "flex"
      } ${elementClassAttribute} ${s.CheckboxContainer} ${className}`}
    >
      <CheckboxPrimitive.Root
        defaultChecked
        id={color}
        className={`${
          s.ColorCheckbox
        } w-[40px] h-[40px]  !border-gray-600 ${getColorClass(color)} ${
          disabled ? "opacity-5  pointer-events-none" : ""
        } `}
        onCheckedChange={onCheckedChange}
        checked={checked}
      >
        <CheckboxPrimitive.Indicator className="w-[14px]">
          <Icon type="checkmark" className={`${getColorClass(color)}`} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <Label.Root
        className={` ${disabled ? "opacity-25  pointer-events-none" : ""}`}
        htmlFor={color}
        dangerouslySetInnerHTML={{ __html: label }}
      />
    </div>
  );
};

const getColorClass = (color) => {
  switch (color) {
    case "blau":
      return "bg-[blue] text-white";
    case "braun":
      return "bg-[brown] text-white";
    case "gelb":
      return "bg-[yellow] text-gray-600";
    case "grau":
      return "bg-[gray] text-white";
    case "grun":
      return "bg-[green] text-white";
    case "orange":
      return "bg-[orange] text-white";
    case "rot":
      return "bg-[red] text-white";
    case "schwarz":
      return "bg-[black] text-white";
    case "silber":
      return "bg-[silver] text-white";
    case "violett":
      return "bg-[violet] text-white";
    case "weiss":
      return "bg-[white] text-black";
    default:
      return "bg-gray-100 text-gray-600";
  }
};
